import React from 'react';
import _ from 'lodash';

export const getServiceUrl = () => {
  const serviceUrl =
    window.location.hostname === process.env.REACT_APP_LOCAL
      ? process.env.REACT_APP_SERVICE_LOCAL
      : process.env.REACT_APP_SERVICE;
  return serviceUrl;
};

export const fetchJson = (url, options = {}) => {
  return fetch(url, options)
    .then(response => response.json())
    .catch(error => error);
};

export const fetchApi = (url, method = 'GET', data = {}, headers = {}) => {
  const options = {
    method,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      ...headers
    }
  };
  if (method === 'POST' || method === 'PUT') {
    if (headers !== false) {
      options.headers = {
        'Content-Type': 'application/json',
        ...options.headers
      };
    }
    options.body = data;
  }
  return fetchJson(`${getServiceUrl()}/${process.env.REACT_APP_API}/${url}`, options);
};

export const toObject = items => {
  return _.keyBy(items, 'id');
};

export const sortCollection = items => {
  return _.orderBy(items, ['created_at'], ['desc']);
};

export const stripHtml = html => {
  const temporalDivElement = document.createElement('div');
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent || temporalDivElement.innerText || '';
};

export const json2table = ({ data, props = {} }) => {
  if (_.isEmpty(data)) return null;
  return (
    <table {...props}>
      <tbody>
        {_.map(data, (value, field) => {
          return (
            <tr key={field}>
              <th align="right">{field}:</th>
              <td key={field} dangerouslySetInnerHTML={{ __html: value }} />
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const array2table = ({
  data,
  props = {
    border: 1,
    cellSpacing: 0,
    cellPadding: 4
  }
}) => {
  if (_.isEmpty(data)) return null;
  return (
    <table {...props}>
      <thead>
        <tr>
          {_.map(data[0], (value, field) => (
            <th key={field}>{field}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {_.map(data, (value, index) => {
          return (
            <tr key={index}>
              {_.map(value, (v, field) => (
                <td key={field} dangerouslySetInnerHTML={{ __html: v }} />
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};



// WEBPACK FOOTER //
// ./src/utils/index.js